import { _invert } from '@naturalcycles/js-lib';
import { HardwareId } from './event.shared.model.js';
export var ProductType = /*#__PURE__*/function (ProductType) {
  ProductType["SUBSCRIPTION"] = "SUBSCRIPTION";
  ProductType["SHOP"] = "SHOP";
  ProductType["OTHER"] = "OTHER";
  ProductType["DISCOUNT"] = "DISCOUNT";
  return ProductType;
}(ProductType || {});
export var ProductDurationUnit = /*#__PURE__*/function (ProductDurationUnit) {
  ProductDurationUnit["DAY"] = "day";
  ProductDurationUnit["MONTH"] = "month";
  return ProductDurationUnit;
}(ProductDurationUnit || {});
export var ThermometerUnit = /*#__PURE__*/function (ThermometerUnit) {
  ThermometerUnit["fahrenheit"] = "fahrenheit";
  ThermometerUnit["celsius"] = "celsius";
  return ThermometerUnit;
}(ThermometerUnit || {});
export var ProductKey = /*#__PURE__*/function (ProductKey) {
  ProductKey["YEAR"] = "YEAR";
  ProductKey["YEAR_RETAIL"] = "YEAR_RETAIL";
  ProductKey["HALFYEAR"] = "HALFYEAR";
  ProductKey["HALFYEAR_RETAIL"] = "HALFYEAR_RETAIL";
  ProductKey["QUARTER"] = "QUARTER";
  ProductKey["QUARTER_RETAIL"] = "QUARTER_RETAIL";
  ProductKey["MONTH"] = "MONTH";
  ProductKey["TRIAL"] = "TRIAL";
  ProductKey["ROLLING_TRIAL"] = "ROLLING_TRIAL";
  ProductKey["ROLLING_TRIAL_7DAYS"] = "ROLLING_TRIAL_7DAYS";
  ProductKey["SEVENDAY"] = "SEVENDAY";
  ProductKey["TWO_YEAR"] = "TWO_YEAR";
  /**
   * For subscriptions created by adding months
   */
  ProductKey["TEMP"] = "TEMP";
  /**
   * @description
   * T1 - Our first generation oral thermometer.
   *
   * @link https://help.naturalcycles.com/hc/en-us/articles/360003343414-What-is-the-NC-Thermometer-Gen1-
   *
   * @note
   * Has two variants, fahrenheit and celsius.
   * This is because the device is hardcoded to be either a fahrenheit or celsius thermometer.
   */
  ProductKey["THERMOMETER"] = "THERMOMETER";
  /**
   * @description
   * T2 - Our second generation oral thermometer.
   *
   * @link https://help.naturalcycles.com/hc/en-us/articles/4412619013777-How-to-measure-with-the-NC-Thermometer-Gen2
   *
   * @note
   * Does not have variants
   * This is a bluetooth thermometer that has a digital switch to change between fahrenheit and celsius.
   */
  ProductKey["BT_THERMOMETER"] = "BT_THERMOMETER";
  /**
   * @description
   * T3 - Our third generation oral thermometer.
   *
   * @link https://help.naturalcycles.com/hc/en-us/articles/9242253594909-What-is-the-NC-Thermometer-Gen3-
   *
   * @note
   * Does not have variants
   * This is a bluetooth thermometer that has a digital switch to change between fahrenheit and celsius.
   */
  ProductKey["T3_THERMOMETER"] = "T3_THERMOMETER";
  /**
   * CouponCode, for backwards compatibility
   */
  ProductKey["CODE"] = "CODE";
  ProductKey["FOURMONTH"] = "FOURMONTH";
  ProductKey["OVUL_TEST"] = "OVUL_TEST";
  ProductKey["OVUL_TEST_CLEARBLUE"] = "OVUL_TEST_CLEARBLUE";
  ProductKey["GIVZ_DONATION"] = "GIVZ_DONATION";
  ProductKey["PREG_TEST"] = "PREG_TEST";
  ProductKey["PREG_TEST_CLEARBLUE"] = "PREG_TEST_CLEARBLUE";
  ProductKey["AMAZON_GIFT_CARD"] = "AMAZON_GIFT_CARD";
  ProductKey["YOPPIE_TAMPON"] = "YOPPIE_TAMPON";
  ProductKey["LELO_CONDOMS"] = "LELO_CONDOMS";
  ProductKey["LELO_CONDOMS_3PK"] = "LELO_CONDOMS_3PK";
  ProductKey["SUSTAIN_CONDOMS_10"] = "SUSTAIN_CONDOMS_10";
  ProductKey["CHRISTMAS_LEAFLET_EU"] = "CHRISTMAS_LEAFLET_EU";
  ProductKey["CHRISTMAS_LEAFLET_US"] = "CHRISTMAS_LEAFLET_US";
  ProductKey["CORA_PERIOD_STARTER_KIT"] = "CORA_PERIOD_STARTER_KIT";
  ProductKey["OURA_RING_DISCOUNT"] = "OURA_RING_DISCOUNT";
  ProductKey["OURA_RING"] = "OURA_RING";
  ProductKey["OURA_MONTH"] = "OURA_MONTH";
  ProductKey["OURA_SHIPPING"] = "OURA_SHIPPING";
  ProductKey["APPLE_WATCH"] = "APPLE_WATCH";
  /**
   * @deprecated
   */
  ProductKey["YEAR_ACTIVATION_CARD"] = "YEAR_ACTIVATION_CARD";
  /**
   * @deprecated
   */
  ProductKey["MONTH_ACTIVATION_CARD"] = "MONTH_ACTIVATION_CARD";
  /**
   * @deprecated
   */
  ProductKey["ROLLING_TRIAL_ACTIVATION_CARD"] = "ROLLING_TRIAL_ACTIVATION_CARD";
  /**
   * @deprecated
   */
  ProductKey["OVUL_TEST_UK"] = "OVUL_TEST_UK";
  /**
   * @deprecated
   */
  ProductKey["OVUL_TEST_US"] = "OVUL_TEST_US";
  /**
   * @deprecated
   */
  ProductKey["OVUL_TEST_SE"] = "OVUL_TEST_SE";
  /**
   * @deprecated
   */
  ProductKey["PREG_TEST_UK"] = "PREG_TEST_UK";
  /**
   * @deprecated
   */
  ProductKey["PREG_TEST_US"] = "PREG_TEST_US";
  /**
   * @deprecated
   */
  ProductKey["PREG_TEST_SE"] = "PREG_TEST_SE";
  // Not used yet
  ProductKey["B1"] = "B1";
  ProductKey["SUBSCRIPTION_PRORATION_DISCOUNT"] = "SUBSCRIPTION_PRORATION_DISCOUNT";
  ProductKey["SUBSCRIPTION_CREDIT_DISCOUNT"] = "SUBSCRIPTION_CREDIT_DISCOUNT";
  // Not used yet
  ProductKey["SAMSUNG_RING"] = "SAMSUNG_RING";
  return ProductKey;
}(ProductKey || {});
export var SKU = /*#__PURE__*/function (SKU) {
  SKU["THERMOMETER_CLEARBLUE"] = "0073-CB1";
  SKU["THERMOMETER_ACTIVATION_CARD"] = "0073-02";
  SKU["THERMOMETER_US"] = "0073";
  SKU["THERMOMETER_FAHRENHEIT"] = "0072";
  SKU["THERMOMETER_CELSIUS"] = "0071";
  SKU["THERMOMETER_AU"] = "0071-AU";
  SKU["OVUL_TEST_CLEARBLUE"] = "RE0005-LH-CL";
  SKU["OVUL_TEST_CLEARBLUE_US"] = "WB0052";
  SKU["OVUL_TEST_SE"] = "10-0002";
  SKU["OVUL_TEST"] = "110004";
  SKU["PREG_TEST_CLEARBLUE"] = "RE0005-PG-CL";
  SKU["PREG_TEST_CLEARBLUE_US"] = "WB0051";
  SKU["PREG_TEST_SE"] = "101-PRE-SE";
  SKU["PREG_TEST"] = "110003";
  SKU["T3_THERMOMETER"] = "BU01";
  SKU["T3_THERMOMETER_LATEST_FW"] = "NC0002-T3-FW";
  SKU["BT_THERMOMETER"] = "0074";
  SKU["BT_THERMOMETER_US"] = "0074-US";
  SKU["YOPPIE_TAMPON"] = "0102";
  SKU["LELO_CONDOMS"] = "WB0003";
  SKU["LELO_CONDOMS_3PK"] = "WB0027";
  SKU["SUSTAIN_CONDOMS_10"] = "10CF02";
  SKU["CHRISTMAS_LEAFLET_EU"] = "1120";
  SKU["CHRISTMAS_LEAFLET_US"] = "1121";
  SKU["CORA_PERIOD_STARTER_KIT"] = "XVSMPERIODKIT";
  SKU["B1"] = "BU02";
  return SKU;
}(SKU || {});
export const skuToHarwareIdMap = {
  [SKU.THERMOMETER_CLEARBLUE]: HardwareId.ORAL_THERMOMETER,
  [SKU.THERMOMETER_US]: HardwareId.ORAL_THERMOMETER,
  [SKU.THERMOMETER_FAHRENHEIT]: HardwareId.ORAL_THERMOMETER,
  [SKU.THERMOMETER_CELSIUS]: HardwareId.ORAL_THERMOMETER,
  [SKU.THERMOMETER_AU]: HardwareId.ORAL_THERMOMETER,
  [SKU.BT_THERMOMETER]: HardwareId.UEBE_THERMOMETER,
  [SKU.T3_THERMOMETER]: HardwareId.T3_THERMOMETER,
  [SKU.T3_THERMOMETER_LATEST_FW]: HardwareId.T3_THERMOMETER,
  [SKU.B1]: HardwareId.B1
};
export const PLAN_VALUES = [ProductKey.YEAR, ProductKey.YEAR_RETAIL, ProductKey.HALFYEAR, ProductKey.HALFYEAR_RETAIL, ProductKey.QUARTER, ProductKey.QUARTER_RETAIL, ProductKey.MONTH, ProductKey.TRIAL, ProductKey.CODE, ProductKey.FOURMONTH, ProductKey.TEMP, ProductKey.ROLLING_TRIAL, ProductKey.ROLLING_TRIAL_7DAYS, ProductKey.SEVENDAY, ProductKey.TWO_YEAR];
export const trialKeys = [ProductKey.TRIAL, ProductKey.ROLLING_TRIAL, ProductKey.ROLLING_TRIAL_7DAYS, ProductKey.SEVENDAY];
export const rollingTrialKeys = [ProductKey.ROLLING_TRIAL, ProductKey.ROLLING_TRIAL_7DAYS];
/**
 * It's not `Partial`, because every HardwareId is expected to have a
 * corresponding ProductKey.
 */
export const productKeyByHwId = {
  [HardwareId.ORAL_THERMOMETER]: ProductKey.THERMOMETER,
  [HardwareId.UEBE_THERMOMETER]: ProductKey.BT_THERMOMETER,
  [HardwareId.T3_THERMOMETER]: ProductKey.T3_THERMOMETER,
  [HardwareId.OURA]: ProductKey.OURA_RING_DISCOUNT,
  [HardwareId.APPLE_WATCH]: ProductKey.APPLE_WATCH,
  [HardwareId.B1]: ProductKey.B1,
  [HardwareId.SAMSUNG_RING]: ProductKey.SAMSUNG_RING
};
export const hwIdByProductKey = Object.fromEntries(Object.entries(_invert(productKeyByHwId)).map(([k, v]) => {
  return [k, Number(v)];
}));
export const thermometerKeys = [ProductKey.THERMOMETER, ProductKey.BT_THERMOMETER, ProductKey.T3_THERMOMETER];
/**
 * Avoid using in the frontend if possible since it's quite hacky
 */
export var ProductVariant = /*#__PURE__*/function (ProductVariant) {
  // T1
  ProductVariant["fahrenheit"] = "fahrenheit";
  ProductVariant["celsius"] = "celsius";
  // Subscription with T1
  ProductVariant["thermometer"] = "thermometer";
  ProductVariant["withThermometer"] = "withThermometer";
  ProductVariant["thermometerOptional"] = "thermometerOptional";
  // Subscription with T2
  ProductVariant["includesBluetoothThermometer"] = "includesBluetoothThermometer";
  ProductVariant["withBluetoothThermometer"] = "withBluetoothThermometer";
  ProductVariant["bluetoothThermometerOptional"] = "bluetoothThermometerOptional";
  // Subscription with T3
  ProductVariant["includesT3"] = "includesT3";
  ProductVariant["withT3"] = "withT3";
  ProductVariant["t3Optional"] = "t3Optional";
  // Third Party Devices
  ProductVariant["thirdPartyDevice"] = "thirdPartyDevice";
  ProductVariant["ownsDevice"] = "ownsDevice";
  ProductVariant["wantsDevice"] = "wantsDevice";
  ProductVariant["visibleInCartSummary"] = "visibleInCartSummary";
  ProductVariant["noThermometer"] = "noThermometer";
  return ProductVariant;
}(ProductVariant || {});
export function getThermometerVariants(key, country) {
  if (key !== ProductKey.THERMOMETER) return;
  // Australia only has celsius thermometers
  return country === 'AU' ? [ThermometerUnit.celsius] : [ThermometerUnit.fahrenheit, ThermometerUnit.celsius];
}
export function isThermometerKey(key) {
  return thermometerKeys.includes(key);
}
export function isTrialKey(key) {
  return trialKeys.includes(key);
}
export function isRollingTrialKey(key) {
  return rollingTrialKeys.includes(key);
}